import {combineReducers} from '@reduxjs/toolkit';

import {accountSearchResultColumns} from './slices/account-search-result-columns.slice';
import {accountSearchResultConferenceUsersSlice} from './slices/account-search-result-conference-users.slice';
import {accountSearchResultCreditAlertsUsersSlice} from './slices/account-search-result-credit-alerts-users.slice';
import {accountSearchResultCrmIntegrationSlice} from './slices/account-search-result-crm-integration.slice';
import {accountSearchResultCrmUsersSlice} from './slices/account-search-result-crm-users.slice';
import {accountSearchResultDisabledUsersSlice} from './slices/account-search-result-disabled-users.slice';
import {accountSearchResultLicenseSlice} from './slices/account-search-result-license.slice';
import {accountSearchResultLicensedUsersSlice} from './slices/account-search-result-licensed-users.slice';
import {accountSearchResultMobileUsersSlice} from './slices/account-search-result-mobile-users.slice';
import {accountSearchResultNoAccessUsersSlice} from './slices/account-search-result-no-access-users.slice';
import {accountSearchResultParentAccountsSlice} from './slices/account-search-result-parent-accounts.slice';
import {accountSearchResultPrimaryManagerSlice} from './slices/account-search-result-primary-manager.slice';
import {accountSearchResultStateSlice} from './slices/account-search-result-state.slice';
import {accountSearchResultSlice} from './slices/account-search-result.slice';

export const accountSearchResultReducer = combineReducers({
    columns: accountSearchResultColumns.reducer,
    result: accountSearchResultSlice.reducer,
    state: accountSearchResultStateSlice.reducer,

    license: accountSearchResultLicenseSlice.reducer,
    crmUsers: accountSearchResultCrmUsersSlice.reducer,
    mobileUsers: accountSearchResultMobileUsersSlice.reducer,
    noAccessUsers: accountSearchResultNoAccessUsersSlice.reducer,
    disabledUsers: accountSearchResultDisabledUsersSlice.reducer,
    licensedUsers: accountSearchResultLicensedUsersSlice.reducer,
    parentAccounts: accountSearchResultParentAccountsSlice.reducer,
    crmIntegration: accountSearchResultCrmIntegrationSlice.reducer,
    primaryManager: accountSearchResultPrimaryManagerSlice.reducer,
    conferenceUsers: accountSearchResultConferenceUsersSlice.reducer,
    creditAlertsUsers: accountSearchResultCreditAlertsUsersSlice.reducer,
});
